// src/components/vendor/RevenueChart.jsx
import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Stack,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Area,
  AreaChart,
} from 'recharts';
import { useState } from 'react';

const RevenueChart = ({ data = [] }) => {
  const [timeRange, setTimeRange] = useState('6months');

  // If no data, provide mock data
  const chartData = data.length > 0 ? data : [
    { month: 'Jan', revenue: 1250, orders: 45 },
    { month: 'Feb', revenue: 1800, orders: 52 },
    { month: 'Mar', revenue: 2200, orders: 68 },
    { month: 'Apr', revenue: 1900, orders: 55 },
    { month: 'May', revenue: 3100, orders: 89 },
    { month: 'Jun', revenue: 2800, orders: 76 },
  ];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Paper sx={{ p: 2, borderRadius: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold">
            {label}
          </Typography>
          <Typography variant="body2" color="primary">
            Revenue: ${payload[0].value.toFixed(2)}
          </Typography>
          {payload[1] && (
            <Typography variant="body2" color="info.main">
              Orders: {payload[1].value}
            </Typography>
          )}
        </Paper>
      );
    }
    return null;
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight="bold">
          Revenue Overview
        </Typography>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Time Range</InputLabel>
          <Select
            value={timeRange}
            onChange={(e) => setTimeRange(e.target.value)}
            label="Time Range"
          >
            <MenuItem value="1month">Last Month</MenuItem>
            <MenuItem value="3months">Last 3 Months</MenuItem>
            <MenuItem value="6months">Last 6 Months</MenuItem>
            <MenuItem value="1year">Last Year</MenuItem>
          </Select>
        </FormControl>
      </Stack>

      <Box sx={{ height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis yAxisId="left" />
            <YAxis yAxisId="right" orientation="right" />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Area
              yAxisId="left"
              type="monotone"
              dataKey="revenue"
              stroke="#d32f2f"
              fill="#d32f2f"
              fillOpacity={0.1}
              name="Revenue ($)"
              strokeWidth={2}
            />
            <Area
              yAxisId="right"
              type="monotone"
              dataKey="orders"
              stroke="#2196f3"
              fill="#2196f3"
              fillOpacity={0.1}
              name="Orders"
              strokeWidth={2}
            />
          </AreaChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

export default RevenueChart;